<template src="./template.html"></template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import Dropdown from '@/components/global/dropdown';
import TableMenu from './tableMenu.vue';
import TableSearch from './tableSearch.vue';
import TableHeader from './tableHeader.vue';
import TableRow from './tableRow.vue';
import AllShipmentsRow from './allShipmentsRow.vue';
import BookedPickupsRow from "./bookedPickupsRow";
import NotPlannedPickupsRow from "./notPlannedPickupsRow";
import TableRowSkeleton from './tableRowSkeleton.vue';

export default {
  name: 'DataTable',
  props: [
    'tableHead',
    'list',
    'singleLine',
    'referenceData',
    'checkbox',
    'type',
    'rowActionParameter',
    'count',
    'filterOptions',
    'tableActions',
    'tableAPI',
    'totalCount',
    'dropdown',
    'customTable',
    'tableHeader',
    'actionsOptions',
    'apiID',
    'updateIterator',
    'detailView',
    'fieldFormatterConfiguration',
    'showRowValueWithPrefix'
  ],
  components: {
    Btn,
    Dropdown,
    TableHeader,
    TableRow,
    AllShipmentsRow,
    BookedPickupsRow,
    NotPlannedPickupsRow,
    TableRowSkeleton,
    TableMenu,
    TableSearch,
  },
  data() {
    return {
      skeletonAmount: 15,
      skeletonLoadingList: 2,
      loading: false,
      loadedPage: 1,
      pageEnd: false,
      selectedItems: [],
      selectTotalRows: false,
      firstTimeLoading: false,
    };
  },
  computed: {
    ...mapGetters([
      'get_active_filter',
      'get_active_filter_name',
      'get_search_term',
      'get_all_shipments_query',
      'get_data_no_found_status'
    ]),
    textForItems() {
      if (this.selectedItems.length > 1) {
        return `items selected of ${this.count} loaded!`;
      }
      return `item selected of ${this.count} loaded!`;
    },
    computedActionsOptions() {
      return this.actionsOptions;
    },
    randomIconId() {
      return `icon-${this.randomNumber()}`
    },
  },
  mounted() {
    //console.log(this.list)
    //Reset data not found to false
    this.$store.commit('RESET_DATA_NOT_FOUND');
    if(this.tableHead){
      this.loading = true;
      // IF FILTER EXIST CALL FILTER PARAM BEFORE CALLING DATA
      // 1. Step - get filters from server
      this.$store.dispatch('STORE_SIDEBAR_FIELDS', {
        sidebarFields: this.filterOptions.filterFields,
        sidebarTableName: this.filterOptions.tableName,
        sidebarTableApi: this.filterOptions.tableApi,
        tableApi: this.tableActions,
      });
      this.$store.dispatch('GET_FILTERS', this.filterOptions.tableName).then((res)=> {
        this.$store.dispatch('STORE_FILTERS_MENU', res.filters_json);
        if(this.$route.query.hasOwnProperty('searchTerm') || this.$route.query.hasOwnProperty('search')){
          let searchObject = {
            searchTerm: '',
            search: [],
          };
          // Chek for searchTerm
          if(this.$route.query.hasOwnProperty('searchTerm')){
            searchObject.searchTerm = this.$route.query.searchTerm;
            this.$store.dispatch('STORE_SEARCH', searchObject.searchTerm)
          }
          // Check for search object - filter
          if(this.$route.query.hasOwnProperty('search')){
            searchObject.search = JSON.parse(this.$route.query.search);
          }
          this.$store.dispatch('STORE_ACTIVE_FILTER', {
            name: '',
            params: searchObject.search,
          }).then(() => {
            this.$store.dispatch(`TABLE_SEARCH`, {
              pageApiURL: this.filterOptions.tableApi,
              filter: searchObject.search,
              searchTerm: searchObject.searchTerm,
            }).then((res) => {
              this.$store.dispatch(`CLEAR_${this.tableActions}`);
              this.$store.dispatch(`STORE_${this.tableActions}`, res);
              if( this.count < this.loadedPage * 50 ){
                this.pageEnd = true;
              }
            }).finally(() => this.loading = false);
          });
        } else {
          this.$store.dispatch(`TABLE_SEARCH`, {
            pageApiURL: this.filterOptions.tableApi,
          }).then((res) => {
            this.$store.dispatch(`CLEAR_${this.tableActions}`);
            this.$store.dispatch(`STORE_${this.tableActions}`, res);
          }).finally(() => this.loading = false);
        }
      });
    } else {
      // IF NO FILTER NEEDED JUST CALL DATA
      this.$store.dispatch(`GET_${this.tableActions}`, {
        page: this.loadedPage,
        id: this.apiID,
      });
    }
  },
  destroyed() {
    this.$store.dispatch(`CLEAR_${this.tableActions}`);
    this.$store.dispatch('CLEAR_FILTERS_MENU');
    this.$store.dispatch('CLEAR_ACTIVE_FILTER');
    this.$store.dispatch('CLEAR_SEARCH');
    this.$store.dispatch('CLEAR_SIDEBAR_FIELDS');
  },
  methods: {
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    startFilter(filter) {
      // pocisti tabelu - mozda da se prebaci kad je nova ucitana
      this.$store.dispatch(`CLEAR_${this.tableActions}`);
      this.$store.dispatch('STORE_ACTIVE_FILTER', filter.filter).then(() => {
        this.$store.dispatch(`TABLE_SEARCH`, {
          pageApiURL: this.filterOptions.tableApi,
          filter: filter.filter.params,
          searchTerm: filter.searchTerm,
        }).then((res) => {
          this.$store.dispatch(`STORE_${this.tableActions}`, res);
        });
      });
    },
    resetFilter() {
      this.loadedPage = 1;
      this.$store.dispatch(`CLEAR_${this.tableActions}`);
      this.$store.dispatch(`TABLE_SEARCH`, {
          pageApiURL: this.filterOptions.tableApi,
        }).then((res) => {
          this.$store.dispatch(`STORE_${this.tableActions}`, res);
        });
      this.$store.dispatch('CLEAR_ACTIVE_FILTER');
    },
    dispatchRowAction(val) {
      this.$emit('rowAction', val);
    },
    actions(val) {
      this.$emit('actionOptionTriggered', {
        dropOption: val,
        list: this.selectedItems,
      });
    },
    selectAll() {
      if(this.selectTotalRows){
        this.selectedItems = [];
        this.selectTotalRows = false;
      } else {
        this.selectedItems = this.list.map(item => item.id);
        this.selectTotalRows = true;
      }
    },
    updateSelectList(id) {
      const index = this.selectedItems.indexOf(id);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
        this.selectTotalRows = false;
      } else  {
        this.selectedItems.push(id);
      }
    },
    visibilityChanged(isVisible) {
      if(isVisible && (this.count > this.loadedPage * 50)) {
        this.loading = true;
        this.loadedPage++;
        window.scrollTo(0,document.body.scrollHeight);
        this.loadMoreData().then(() => {
          this.loading = false;
          if( this.count < this.loadedPage * 50 ){
            this.pageEnd = true;
          } else {
            this.pageEnd = false;
          }
          if(this.selectTotalRows){
            this.selectedItems = this.list.map(item => item.id);
          }
        });
      }
    },
    async loadMoreData() {
      await this.$store.dispatch(`GET_${this.tableActions}`, {
        page: this.loadedPage,
        id: this.apiID,
        query: this.get_all_shipments_query?'&'+this.get_all_shipments_query.substring(1):''
      });
    },
    resetTable() {
      this.loading = true;
      this.loadedPage = 1;
      this.pageEnd = false;
      window.scrollTo(0,0);
    },
    stopLoading() {
      this.loading = false;
    },
  },
  watch: {
    count: function(val) {
      if( this.count < this.loadedPage * 50 ){
        this.pageEnd = true;
      } else {
        this.pageEnd = false;
      }
    },
    selectedItems: function (val) {
      this.$emit('updatedSelections', {
        selectedList: val,
        selectTotalRows: this.selectTotalRows,
      });
    },
    // loading: function () {
    //   if(this.loading) {
    //     setTimeout(() => {
    //       window.scrollTo(0,document.body.scrollHeight);
    //     }, 100);
    //   }
    // },
    updateIterator() {
      this.loadedPage = 1;
      let queryString = '';
      if(this.$route.query.hasOwnProperty('search')){
        queryString += `&search=${this.$route.query.search}`;
        queryString += `&searchTerm=${this.$route.query.searchTerm}`;
      }
      this.$store.dispatch(`GET_${this.tableAPI}`, {
        page: 1,
        id: this.apiID,
        query: queryString,
      }).then(() => {
        this.selectedItems = [];
        this.selectTotalRows = false;
        if( this.count < this.loadedPage * 50 ){
          this.pageEnd = true;
        }
      });
    },
  }
}
</script>
